import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

/**
 * Formatte les durées des STI
 */
@Pipe({
  name: 'durationGauge',
  standalone: true,
})
export class DurationGaugePipe implements PipeTransform {
  transform(value: number | moment.Duration) {
    let momentDuration: moment.Duration = <moment.Duration>value;
    if (typeof value === 'number') {
      momentDuration = moment.duration(value, 'minutes');
    }
    const days = momentDuration.get('days');
    const minutes = momentDuration.get('minutes');
    const hours = momentDuration.get('hours') + days * 24;
    let resultString = '';

    if (hours === 0 && minutes <= 0) {
      return '0h';
    }

    if (hours !== 0) {
      resultString += hours + 'h';
    }
    if (minutes !== 0) {
      resultString += minutes < 10 ? '0' + minutes : minutes;
    }
    if (hours === 0) {
      resultString += 'min';
    }

    return resultString;
  }
}
